import { ViewTreeNode } from '../../models/view.tree-node';
import { HitModel } from '../../models/hit.model';
import { BdGraph } from 'src/lib/graph/graph.model';

export class HoverNode {
  static readonly type = '[Engine Nodes] Hover Node';
  constructor(public node: ViewTreeNode, public hit?: HitModel) { }
}

export class SelectNode {
  static readonly type = '[Engine Nodes] Select Node';
  constructor(public node: ViewTreeNode) {}
}

export class CheckNode {
  static readonly type = '[Engine Nodes] Check Node';
  constructor(public node: ViewTreeNode, public checked: boolean) { }
}

export class CheckAllNodes {
  static readonly type = '[Engine Nodes] Check All Nodes';
  constructor() { }
}

export class CheckInverseNodes {
  static readonly type = '[Engine Nodes] Check Inverse Nodes';
  constructor(public nodes: ViewTreeNode[]) { }
}

export class ExpandNode {
  static readonly type = '[Engine Nodes] Expand Node';
  constructor(public node: ViewTreeNode) { }
}

export class CollapseNode {
  static readonly type = '[Engine Nodes] Collapse Node';
  constructor(public node: ViewTreeNode) { }
}

export class SetCheckedNodes {
  static readonly type = '[Engine Nodes] Set Checked Nodes';
  constructor(public nodes: ViewTreeNode[]) { }
}

export class ToggleVisibleNodes {
  static readonly type = '[Engine Nodes] Toggle Visible Nodes';
  constructor(public nodes: ViewTreeNode[], public visible: boolean, public recordHistory = true) { }
}

export class TogglePickableNodes {
  static readonly type = '[Engine Nodes] Toggle Pickable Nodes';
  constructor(public nodes: ViewTreeNode[], public pickable: boolean, public recordHistory = true) { }
}

export class ToggleInversePickableNodes {
  static readonly type = '[Engine Nodes] Toggle Inverse Pickable Nodes';
  constructor(public nodes: ViewTreeNode[], public viewGraph: BdGraph<ViewTreeNode>, public pickable: boolean) {}
}

export class ResetEngineNodes {
  static readonly type = '[Engine Nodes] Reset';
  constructor() { }
}

export class HideInverse {
  static readonly type = '[Engine Nodes] Hide Inverse';
  constructor(public nodes: ViewTreeNode[], public viewGraph: BdGraph<ViewTreeNode>) {}
}

export class Isolate {
  static readonly type = '[Engine Nodes] Isolate';
  constructor(public nodes: ViewTreeNode[], public viewGraph: BdGraph<ViewTreeNode>) {}
}
